export const state = () => ({
	skills: null,
	user_skills: null,
});

export const mutations = {
	setSkills(state: any, payload: any) {
		state.skills = payload;
	},
	setUserSkills(state: any, payload: any) {
		state.user_skills = payload;
	},
};

export const getters = {
	getSkills: (state: any) => state.skills,
	getUserSkills: (state: any) => state.user_skills,
};

export const actions = {
	async fetchSkills(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/skills')
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async fetchUserSkills(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/skills')
				.then((res) => {
					state.commit('setUserSkills', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeUserSkills(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/skills', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteUserSkill(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/skills/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateSkills(state: any, payload: any) {
		state.commit('setSkills', payload);
	},

	updateUserSkills(state: any, payload: any) {
		state.commit('setSkills', payload);
	},
};
